import { useLayoutEffect, useState } from "react"

export declare class ResizeObserver {
  constructor(callback: () => void)
  observe(target: Element): void
  unobserve(target: Element): void
  disconnect(): void
}

export const useIsOverflow = (element?: HTMLElement) => {
  const [isOverflow, setIsOverflow] = useState(false)

  useLayoutEffect(() => {
    let resizeObserver: ResizeObserver
    if (element != null) {
      const trigger = () => {
        const hasOverflow = element.scrollHeight > element.clientHeight // vertical overflow
        setIsOverflow(hasOverflow)
      }

      if (element) {
        resizeObserver = new ResizeObserver(trigger)
        resizeObserver.observe(element)
        trigger()
      }
    }
    return () => {
      if (element && resizeObserver) {
        resizeObserver.unobserve(element)
      }
    }
  }, [element])

  return isOverflow
}
